module.exports = __webpack_public_path__ + "static/media/galerija_2013 (28).0e8642e1.jpg";